'use strict';

angular.module('contentful').directive('cfAppContainer', ['require', require => ({
  template: require('components/app_container/AppContainer').default(),
  restrict: 'E',

  // FIXME move this further down maybe
  controller: 'SpaceController'
})]);



// WEBPACK FOOTER //
// ./src/javascripts/components/app_container/cf_app_container_directive.js